import { Text } from '@usealloy/component-library';
import styled from 'styled-components';

interface StyledTextProps {
  bold?: boolean;
  color?: string;
}

export const StyledText = styled(Text)<StyledTextProps>`
  && {
    font-family: var(--cl-font-family-mono);
    line-height: var(--cl-line-height-1);
    width: fit-content;
    ${({ bold }) => bold && 'font-weight: var(--cl-font-weight-bold)'};
    ${({ color }) => color}
  }
`;
